var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHappyAsset11(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 29,
    viewBox: "0 0 48 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "happyAsset 1 1",
    clipPath: "url(#clip0_5253_12571)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer 14"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M44.313 12.7731C44.1115 11.5929 43.7313 10.4483 43.1848 9.37652C42.9091 8.84208 42.5923 8.32865 42.2371 7.8406C42.0589 7.59705 41.8671 7.36008 41.6663 7.13408C41.4661 6.90058 41.2497 6.68065 41.0187 6.47583L40.8224 6.30469L40.1996 7.02437L40.4095 7.16041C40.7953 7.54698 41.14 7.9704 41.4384 8.42425C41.7482 8.88294 42.0213 9.36415 42.2552 9.86362C42.7251 10.8595 43.0406 11.9176 43.1916 13.0035C43.3444 14.0885 43.3504 15.1884 43.2096 16.275C43.0794 17.3523 42.7692 18.4017 42.2913 19.3819C41.8083 20.362 41.187 21.2719 40.4456 22.0851C39.3273 23.3156 38.0038 24.354 36.5307 25.1569C36.2803 25.293 36.0321 25.4159 35.7907 25.5256C35.5477 25.6391 35.2975 25.7373 35.0415 25.8196C34.9716 25.8415 34.9174 25.8569 34.8678 25.8679L34.755 25.8898L34.6783 25.903L34.2495 25.982C33.963 26.0368 33.6764 26.0939 33.3921 26.1531C32.8122 26.2694 32.2391 26.3923 31.6863 26.5151L31.2079 26.6205L31.5193 27.937L31.9977 27.8316C32.5505 27.7088 33.1439 27.5793 33.7396 27.4586L34.6106 27.2853L35.0461 27.2041C35.217 27.1717 35.3851 27.1269 35.5492 27.0703C36.139 26.8612 36.7084 26.6012 37.2505 26.2935C37.7857 25.9975 38.3033 25.6722 38.8007 25.3193C39.7977 24.612 40.7064 23.7939 41.5083 22.8816C42.3174 21.9678 42.9862 20.945 43.4939 19.8449C44.0026 18.7409 44.3205 17.5629 44.4349 16.3583C44.5575 15.1633 44.5165 13.9577 44.313 12.7731ZM43.943 16.3057C43.8323 17.458 43.5274 18.5848 43.0404 19.6408C42.5512 20.6993 41.9075 21.6837 41.1293 22.5634C40.3525 23.4467 39.4726 24.239 38.5073 24.9244C38.0257 25.2665 37.5247 25.5822 37.0068 25.8701C36.4898 26.1615 35.9477 26.4089 35.3868 26.6095C35.2457 26.6586 35.1008 26.6968 34.9535 26.7236L34.5135 26.807L33.6358 26.9803C33.0379 27.1032 32.4422 27.2348 31.8871 27.3555L31.7946 26.9693C32.3452 26.8465 32.9228 26.7258 33.4891 26.6095C33.7735 26.5524 34.0555 26.4954 34.3398 26.4427L34.7685 26.3615L34.8407 26.3484L34.9738 26.333C35.0325 26.3199 35.0979 26.3023 35.1837 26.276C35.4586 26.1868 35.7276 26.0813 35.9892 25.96C36.2419 25.8459 36.5014 25.7165 36.7632 25.5738C37.2689 25.3004 37.7579 24.9985 38.2276 24.6698C39.1735 24.016 40.0389 23.2584 40.8066 22.412C41.5778 21.5648 42.224 20.6173 42.7268 19.5969C43.2275 18.5713 43.5522 17.4728 43.688 16.3452C43.8374 15.2175 43.8344 14.0756 43.679 12.9486C43.4442 11.2433 42.8189 9.61095 41.849 8.17192C41.8242 8.13681 41.7994 8.10171 41.7768 8.0666C41.7926 8.09074 41.8107 8.11268 41.8265 8.13462C42.1654 8.60079 42.4672 9.09152 42.729 9.60252C43.2559 10.632 43.6239 11.7314 43.8211 12.8652C44.0173 14.0018 44.0582 15.1587 43.943 16.3057Z",
    fill: "#D42900"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M44.0716 12.8116C43.8688 11.6542 43.4925 10.532 42.9547 9.48089C42.686 8.95872 42.3759 8.45768 42.0273 7.98227C41.8536 7.74311 41.6663 7.51492 41.47 7.29331C41.2741 7.07196 41.0638 6.86308 40.8404 6.66797L40.5742 6.97296C40.5742 6.97296 40.6035 7.00148 40.6396 7.03659L40.5719 6.97296C40.975 7.37572 41.3356 7.81675 41.6482 8.28946C42.597 9.69877 43.2078 11.2975 43.4353 12.9674C43.5913 14.0728 43.5974 15.1934 43.4533 16.3003C43.3191 17.4025 43.0022 18.4762 42.5147 19.4797C42.0208 20.48 41.3868 21.4089 40.6306 22.24C39.8746 23.0719 39.0237 23.8176 38.0944 24.4626C37.6302 24.7844 37.1481 25.081 36.6503 25.3513C36.4021 25.4873 36.1494 25.6124 35.8945 25.7287C35.6418 25.8461 35.3818 25.948 35.116 26.0337C35.0528 26.0534 34.9874 26.0732 34.9265 26.0863C34.8655 26.0995 34.7956 26.1105 34.7234 26.1236L34.2969 26.2048C34.0104 26.2575 33.7261 26.3145 33.4418 26.3716C32.8732 26.4879 32.3136 26.6085 31.7405 26.7336L31.5013 26.7863L31.5577 27.0188L31.6502 27.4072L31.7044 27.6398L31.9435 27.5871C32.5227 27.4569 33.1048 27.3319 33.69 27.2119C33.981 27.1527 34.2721 27.0934 34.5654 27.0386L35.0032 26.9552C35.1609 26.9259 35.3162 26.8856 35.468 26.8345C36.0432 26.6289 36.5989 26.3748 37.1287 26.0753C37.6555 25.7823 38.1655 25.4615 38.6563 25.1143C39.6368 24.4177 40.5304 23.6121 41.3188 22.7139C42.1126 21.817 42.7692 20.8134 43.2683 19.7342C43.7634 18.6538 44.0744 17.5021 44.1889 16.3245C44.3091 15.1536 44.2697 13.9724 44.0716 12.8116Z",
    fill: "url(#paint0_linear_5253_12571)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M35.9711 27.2612C35.9368 27.2132 35.9066 27.1626 35.8809 27.1098L35.838 27.0308L35.8606 26.9452C35.8741 26.8838 36.2532 25.4488 38.4554 24.773C40.6576 24.0972 42.6184 25.3237 42.7019 25.3764L42.9276 25.519L42.7583 25.7252C42.1184 26.4734 41.356 27.1139 40.502 27.621C38.6495 28.683 36.6661 28.2924 35.9711 27.2612ZM36.366 26.9737L36.3818 27C36.9414 27.8294 38.6653 28.1191 40.247 27.2085C40.9672 26.7805 41.62 26.2536 42.1852 25.6441C41.6098 25.3588 40.1364 24.7664 38.6021 25.2294C36.9527 25.7362 36.4766 26.6863 36.366 26.9737Z",
    fill: "#D42900"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M36.1021 26.9968C36.1021 26.9968 36.436 25.6386 38.5299 24.9957C40.6238 24.3528 42.5711 25.5728 42.5711 25.5728C41.9464 26.2965 41.2049 26.9168 40.3756 27.4093C38.6405 28.4054 36.6594 28.061 36.1021 26.9968Z",
    fill: "url(#paint1_linear_5253_12571)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Vector_5",
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.49
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M42.3116 25.5682C42.3116 25.5682 39.9853 24.5391 38.3652 25.3619C36.7451 26.1847 37.7582 27.7382 38.9 27.6614C40.0417 27.5846 42.4402 25.7656 42.3116 25.5682Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Vector_6",
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.49
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M42.0837 25.6532C42.0837 25.6532 40.4524 26.9873 39.6807 26.882C38.909 26.7767 38.7172 25.7147 39.4392 25.2715C40.1613 24.8282 42.0837 25.6532 42.0837 25.6532Z",
    fill: "white"
  }))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M40.8404 23.5437C40.7969 23.5032 40.7562 23.4599 40.7186 23.4142L40.6599 23.3462V23.2562C40.6599 23.1926 40.7186 21.7203 42.7245 20.5991C44.7304 19.4779 46.9123 20.2788 47.0116 20.3117L47.2666 20.406L47.1583 20.6452C46.6913 21.5085 46.0814 22.2913 45.3532 22.9622C43.7737 24.3818 41.743 24.4082 40.8404 23.5437ZM41.1631 23.1816L41.1856 23.2036C41.9122 23.8991 43.6677 23.8267 45.008 22.6112C45.6184 22.0444 46.1413 21.3948 46.5604 20.6825C45.9376 20.5223 44.3649 20.2436 42.9704 21.016C41.4767 21.8498 41.2172 22.8766 41.1721 23.1816H41.1631Z",
    fill: "#D42900"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M40.9172 23.2619C40.9172 23.2619 40.9511 21.8642 42.8577 20.8066C44.7644 19.749 46.9327 20.5455 46.9327 20.5455C46.4801 21.3818 45.8902 22.1407 45.1863 22.7923C43.7084 24.122 41.6957 24.1944 40.9172 23.2619Z",
    fill: "url(#paint2_linear_5253_12571)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Vector_9",
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.49
  }, _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M46.68 20.5903C46.68 20.5903 44.18 20.0637 42.7765 21.2025C41.373 22.3413 42.702 23.649 43.8009 23.3374C44.8998 23.0258 46.847 20.7571 46.68 20.5903Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Vector_10",
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.49
  }, _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M46.4815 20.7173C46.4815 20.7173 45.1773 22.3585 44.4011 22.4134C43.6249 22.4683 43.2052 21.4721 43.8144 20.8906C44.4236 20.3092 46.4815 20.7173 46.4815 20.7173Z",
    fill: "white"
  }))), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_11",
    d: "M44.3559 17.9575C44.3063 17.9421 44.2544 17.9246 44.207 17.9048L44.1325 17.8763L44.0964 17.8061C44.0694 17.7578 43.4782 16.5861 44.5477 14.9098C45.6172 13.2334 47.6593 12.9636 47.745 12.9526L47.9819 12.9219V13.1545C48.0006 14.0104 47.8749 14.8636 47.6096 15.6799C46.9846 17.4199 45.4277 18.2625 44.3559 17.9575ZM44.4507 17.5538H44.4755C45.3374 17.7995 46.6619 17.0337 47.1832 15.5461C47.4125 14.8593 47.5386 14.144 47.5577 13.4221C47.0072 13.5494 45.6691 13.9685 44.9178 15.1358C44.1145 16.3887 44.3559 17.2905 44.4507 17.5538Z",
    fill: "#D42900"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_12",
    d: "M44.2882 17.7104C44.2882 17.7104 43.7151 16.6133 44.7395 15.0203C45.7639 13.4274 47.7811 13.1641 47.7811 13.1641C47.7857 13.9951 47.6516 14.8213 47.384 15.6106C46.8199 17.2408 45.2901 18.1119 44.2882 17.7104Z",
    fill: "url(#paint3_linear_5253_12571)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Vector_13",
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.49
  }, _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M47.6096 13.3008C47.6096 13.3008 45.448 13.9042 44.8478 15.3567C44.2476 16.8093 45.8384 17.2854 46.5559 16.5986C47.2734 15.9118 47.8104 13.3622 47.6096 13.3008Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Vector_14",
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.49
  }, _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M47.5058 13.4844C47.5058 13.4844 47.1989 15.2858 46.619 15.6434C46.0391 16.0011 45.2878 15.3999 45.5111 14.7021C45.7345 14.0044 47.5058 13.4844 47.5058 13.4844Z",
    fill: "white"
  }))), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_15",
    d: "M44.3446 12.8422C44.2927 12.8422 44.2386 12.8576 44.1867 12.862H44.1054L44.0423 12.8159C43.9971 12.783 42.9321 11.9865 43.1397 10.0227C43.3473 8.05895 45.0396 6.93554 45.1095 6.88727L45.3081 6.75781L45.4232 6.96187C45.823 7.72683 46.0913 8.5503 46.2174 9.39959C46.4543 11.2251 45.4435 12.6535 44.3446 12.8422ZM44.2431 12.4319H44.2679C45.1524 12.2805 45.9895 11.0233 45.7797 9.46102C45.6713 8.74703 45.4586 8.05177 45.1479 7.39631C44.7124 7.74957 43.7038 8.71281 43.5684 10.0732C43.4127 11.5411 44.04 12.2454 44.2431 12.4319Z",
    fill: "#D42900"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_16",
    d: "M44.1709 12.6506C44.1709 12.6506 43.1578 11.9155 43.3473 10.0461C43.5368 8.17665 45.2246 7.06641 45.2246 7.06641C45.6117 7.81045 45.8716 8.61082 45.994 9.4361C46.2242 11.1366 45.2517 12.5781 44.1709 12.6506Z",
    fill: "url(#paint4_linear_5253_12571)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Vector_17",
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.49
  }, _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M45.1276 7.2658C45.1276 7.2658 43.4647 8.74028 43.5888 10.3003C43.7129 11.8604 45.3578 11.6015 45.6872 10.6755C46.0166 9.74959 45.3533 7.24166 45.1276 7.2658Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Vector_18",
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.49
  }, _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M45.1275 7.46875C45.1275 7.46875 45.6758 9.22408 45.3193 9.78579C44.9628 10.3475 44.0151 10.1412 43.8956 9.41936C43.776 8.69748 45.1275 7.46875 45.1275 7.46875Z",
    fill: "white"
  }))), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_19",
    d: "M35.3304 26.5869C35.2702 26.5903 35.21 26.5903 35.1498 26.5869H35.0596L34.9942 26.5255C34.9468 26.4816 33.866 25.4284 34.3827 23.2496C34.8994 21.0708 36.9798 20.0374 37.0678 19.9935L37.3092 19.875L37.4085 20.1207C37.7444 21.0371 37.9242 22.0005 37.941 22.9732C37.9478 25.0598 36.5962 26.5255 35.3304 26.5869ZM35.2762 26.1086H35.3055C36.3254 26.0603 37.4559 24.7614 37.4491 22.9732C37.434 22.1538 37.2972 21.3409 37.043 20.5596C36.4992 20.8975 35.2221 21.83 34.861 23.3549C34.4752 24.9896 35.0754 25.8695 35.2762 26.113V26.1086Z",
    fill: "#D42900"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_20",
    d: "M35.1634 26.3412C35.1634 26.3412 34.13 25.3713 34.6219 23.2913C35.1138 21.2112 37.1784 20.1953 37.1784 20.1953C37.5039 21.0857 37.6784 22.0217 37.6951 22.9665C37.7018 24.9237 36.3909 26.4114 35.1634 26.3412Z",
    fill: "url(#paint5_linear_5253_12571)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Vector_21",
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.49
  }, _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M37.0452 20.4062C37.0452 20.4062 34.9535 21.8368 34.8633 23.6119C34.773 25.387 36.6684 25.3234 37.1716 24.3272C37.6747 23.3311 37.2866 20.4062 37.0452 20.4062Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Vector_22",
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.49
  }, _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M37.0046 20.6406C37.0046 20.6406 37.3634 22.6856 36.8783 23.2736C36.3931 23.8617 35.3552 23.493 35.3281 22.6615C35.3011 21.8299 37.0046 20.6406 37.0046 20.6406Z",
    fill: "white"
  }))), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_23",
    d: "M40.7344 22.7894C40.6835 22.8202 40.6307 22.8481 40.5764 22.8728L40.4952 22.9101L40.4072 22.8882C40.344 22.8728 38.8774 22.4669 38.2411 20.31C37.6048 18.1532 38.918 16.2772 38.9722 16.196L39.1233 15.9766L39.3332 16.1455C40.0852 16.7894 40.7233 17.5492 41.2218 18.3945C42.2665 20.2201 41.8129 22.14 40.7344 22.7894ZM40.4501 22.3967L40.4749 22.3813C41.3436 21.8613 41.6866 20.1872 40.7908 18.6293C40.3694 17.9186 39.845 17.2706 39.2339 16.705C38.9248 17.2558 38.2727 18.6798 38.7149 20.1784C39.191 21.7955 40.1635 22.2826 40.4501 22.3967Z",
    fill: "#D42900"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_24",
    d: "M40.4705 22.6617C40.4705 22.6617 39.0828 22.2997 38.4781 20.2481C37.8734 18.1966 39.1753 16.3359 39.1753 16.3359C39.9035 16.9611 40.5216 17.6978 41.0052 18.5169C41.9845 20.2262 41.5784 22.1439 40.4705 22.6617Z",
    fill: "url(#paint6_linear_5253_12571)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Vector_25",
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.49
  }, _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M39.1639 16.5829C39.1639 16.5829 38.0357 18.8187 38.8503 20.4139C39.6649 22.009 41.2782 21.0721 41.2263 19.9553C41.1744 18.8385 39.3715 16.4578 39.1639 16.5829Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Vector_26",
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.49
  }, _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M39.2452 16.8047C39.2452 16.8047 40.5764 18.4262 40.4456 19.1722C40.3147 19.9182 39.2226 20.0806 38.7871 19.3675C38.3516 18.6544 39.2452 16.8047 39.2452 16.8047Z",
    fill: "white"
  }))), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_27",
    d: "M43.5865 12.7659C43.5639 12.812 43.5414 12.8581 43.5143 12.9042L43.4759 12.9722L43.4015 12.9985C43.3473 13.0182 42.0792 13.4373 40.4975 12.2086C38.9158 10.9799 38.882 8.9744 38.8797 8.88883V8.65625L39.1189 8.676C39.995 8.76864 40.8495 9.00065 41.6483 9.36277C43.3496 10.1614 44.0242 11.7676 43.5865 12.7659ZM43.1759 12.6233L43.1871 12.5992C43.5391 11.7961 42.9164 10.4269 41.4587 9.74675C40.784 9.44399 40.0683 9.23638 39.3332 9.13019C39.3987 9.67873 39.6694 11.0216 40.7705 11.8861C41.9551 12.8098 42.9051 12.6847 43.1759 12.6233Z",
    fill: "#D42900"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_28",
    d: "M43.3225 12.805C43.3225 12.805 42.1356 13.2285 40.6306 12.048C39.1256 10.8676 39.0917 8.89062 39.0917 8.89062C39.9422 8.97868 40.7721 9.20102 41.5489 9.54887C43.1487 10.3168 43.855 11.8857 43.3225 12.805Z",
    fill: "url(#paint7_linear_5253_12571)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Vector_29",
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.49
  }, _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M39.2181 9.06639C39.2181 9.06639 39.5792 11.2255 40.9894 11.9781C42.3996 12.7306 43.0766 11.2496 42.4606 10.475C41.8446 9.70051 39.3061 8.8777 39.2181 9.06639Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Vector_30",
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.49
  }, _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M39.3942 9.19531C39.3942 9.19531 41.1993 9.70436 41.4926 10.3078C41.7859 10.9111 41.0842 11.5628 40.3983 11.2644C39.7123 10.966 39.3942 9.19531 39.3942 9.19531Z",
    fill: "white"
  }))), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_31",
    d: "M42.0589 7.61529C42.0388 7.66355 42.0155 7.71046 41.989 7.75572L41.9506 7.82373L41.8762 7.85006C41.822 7.86981 40.5539 8.29987 38.9722 7.06016C37.3905 5.82046 37.3566 3.82597 37.3544 3.74039V3.50781L37.5935 3.52756C38.4705 3.61981 39.3258 3.85183 40.1252 4.21433C41.8243 5.01301 42.4989 6.61914 42.0589 7.61529ZM41.6505 7.47486V7.45073C42.0025 6.64766 41.3798 5.2785 39.9221 4.59831C39.2474 4.29555 38.5317 4.08794 37.7966 3.98175C37.8621 4.53029 38.1328 5.87312 39.2339 6.73762C40.4298 7.66137 41.3775 7.53849 41.6505 7.47486Z",
    fill: "#D42900"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_32",
    d: "M41.8016 7.65658C41.8016 7.65658 40.6125 8.08005 39.1098 6.89959C37.607 5.71913 37.5709 3.74219 37.5709 3.74219C38.4206 3.83013 39.2499 4.05248 40.0259 4.40044C41.6234 5.15742 42.3296 6.73722 41.8016 7.65658Z",
    fill: "url(#paint8_linear_5253_12571)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Vector_33",
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.49
  }, _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M37.6928 3.92742C37.6928 3.92742 38.0538 6.08648 39.4641 6.83908C40.8743 7.59168 41.5512 6.11281 40.9352 5.33608C40.3192 4.55934 37.7808 3.73214 37.6928 3.92742Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Vector_34",
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.49
  }, _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M37.8688 4.04297C37.8688 4.04297 39.6739 4.55421 39.9672 5.1576C40.2605 5.761 39.5588 6.41267 38.8729 6.11426C38.1869 5.81585 37.8688 4.04297 37.8688 4.04297Z",
    fill: "white"
  }))), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_35",
    d: "M43.6113 18.0807C43.5815 18.1234 43.5491 18.1645 43.5143 18.2035L43.4601 18.2628L43.3812 18.2737C43.327 18.2737 41.9935 18.4515 40.7051 16.9243C39.4167 15.3972 39.8025 13.4356 39.8183 13.3522L39.8635 13.1328L40.0891 13.1986C40.9264 13.4623 41.7137 13.8574 42.4199 14.3681C43.9272 15.4872 44.2499 17.192 43.6113 18.0807ZM43.2413 17.8612L43.2548 17.8393C43.7693 17.124 43.4466 15.6605 42.1627 14.7016C41.5673 14.2701 40.9106 13.925 40.2132 13.677C40.1613 14.2255 40.1433 15.5925 41.0413 16.6566C42.007 17.802 42.9615 17.87 43.2413 17.8612Z",
    fill: "#D42900"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_36",
    d: "M43.3496 18.0586C43.3496 18.0586 42.0995 18.2363 40.8676 16.7838C39.6356 15.3312 40.0327 13.3828 40.0327 13.3828C40.8436 13.6414 41.6057 14.0268 42.2891 14.5238C43.6993 15.577 44.0603 17.2643 43.3496 18.0586Z",
    fill: "url(#paint9_linear_5253_12571)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Vector_37",
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.49
  }, _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M40.1117 13.6022C40.1117 13.6022 40.0124 15.7964 41.2399 16.8035C42.4673 17.8106 43.4376 16.5073 42.9976 15.6252C42.5576 14.7432 40.238 13.4245 40.1117 13.6022Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Vector_38",
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.49
  }, _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M40.2583 13.7461C40.2583 13.7461 41.9168 14.604 42.0792 15.2535C42.2417 15.903 41.4159 16.401 40.8066 15.9732C40.1974 15.5453 40.2583 13.7461 40.2583 13.7461Z",
    fill: "white"
  }))), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_39",
    d: "M3.56508 16.3476C3.68266 17.5524 4.00281 18.7302 4.51276 19.8342C5.02133 20.9343 5.69089 21.9572 6.50063 22.8709C7.30244 23.7833 8.21116 24.6014 9.20829 25.3086C9.7068 25.6611 10.2251 25.9863 10.7607 26.2828C11.3026 26.5909 11.872 26.8509 12.462 27.0596C12.6261 27.1162 12.7943 27.161 12.9652 27.1934L13.4006 27.2746C13.6759 27.3272 13.9602 27.3843 14.2694 27.4479C14.8673 27.5686 15.4607 27.6981 16.0135 27.8209L16.4919 27.9263L16.8033 26.6098L16.3249 26.5044C15.7721 26.3816 15.1967 26.2587 14.6191 26.1424C14.3348 26.0832 14.0482 26.0261 13.7617 25.9713L13.3126 25.8923L13.2359 25.8791L13.1231 25.8572C13.0735 25.8572 13.0193 25.8308 12.9471 25.8089C12.6921 25.7262 12.4426 25.628 12.2003 25.5149C11.9588 25.4052 11.7084 25.2823 11.4579 25.1462C10.9692 24.8795 10.4961 24.5865 10.0409 24.2686C9.1254 23.6325 8.28805 22.8963 7.54534 22.0744C6.80775 21.2633 6.18961 20.3565 5.70864 19.38C5.23076 18.3998 4.92057 17.3504 4.7903 16.273C4.64838 15.1865 4.65445 14.0865 4.80835 13.0015C4.95963 11.916 5.27438 10.8581 5.74249 9.86169C5.97802 9.36262 6.25182 8.88147 6.56156 8.42232C6.85996 7.96847 7.20467 7.54505 7.59047 7.15848L7.79805 7.02245L7.18432 6.32031L6.99027 6.49146C6.75866 6.6957 6.54226 6.91567 6.34269 7.14971C6.14187 7.36912 5.95008 7.61268 5.77182 7.85623C5.41579 8.34375 5.09896 8.85724 4.82414 9.39214C4.27649 10.4583 3.89258 11.5967 3.68467 12.7712C3.48382 13.9531 3.44361 15.1555 3.56508 16.3476ZM4.16979 12.8523C4.36887 11.7187 4.73756 10.6194 5.26414 9.58962C5.52599 9.07862 5.82773 8.58789 6.16669 8.12172C6.18248 8.09978 6.20053 8.07784 6.21633 8.0537L6.14412 8.15902C5.82326 8.63651 5.53966 9.13672 5.29573 9.65544C4.80554 10.6997 4.47706 11.8088 4.32097 12.9467C4.16179 14.0732 4.15496 15.2151 4.30066 16.3433C4.43876 17.4705 4.76336 18.5685 5.26188 19.595C5.76626 20.6145 6.41237 21.5617 7.18206 22.4101C7.95084 23.2555 8.81609 24.0129 9.7611 24.6679C10.2316 24.9966 10.7213 25.2985 11.2278 25.5719C11.4895 25.7145 11.749 25.844 12.0017 25.9581C12.2633 26.0793 12.5323 26.1849 12.8072 26.274C12.8907 26.3004 12.9584 26.3179 13.0171 26.3311L13.157 26.3574L13.2292 26.3706L13.6579 26.4518C13.9399 26.5044 14.2242 26.5615 14.5063 26.6185C15.0817 26.7348 15.6525 26.8555 16.2008 26.9784L16.1106 27.3645C15.5555 27.2439 14.9598 27.1122 14.3596 26.9893C14.0482 26.9257 13.7617 26.8687 13.4819 26.816L13.0441 26.7326C12.8968 26.7058 12.752 26.6677 12.6109 26.6185C12.05 26.418 11.5079 26.1706 10.9908 25.8791C10.4726 25.5908 9.97088 25.2751 9.48808 24.9334C8.52355 24.248 7.6444 23.4557 6.86842 22.5725C6.09165 21.6889 5.45022 20.7008 4.96404 19.6389C4.47604 18.5832 4.17107 17.4563 4.06148 16.3038C3.94189 15.1536 3.9783 13.9932 4.16979 12.8523Z",
    fill: "#D42900"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_40",
    d: "M3.92832 12.8116C4.13003 11.654 4.50639 10.5316 5.04522 9.48089C5.31308 8.95827 5.62318 8.45716 5.9726 7.98227C6.14634 7.74311 6.33362 7.51492 6.52767 7.29331C6.72284 7.07207 6.93236 6.8632 7.15494 6.66797L7.42119 6.97296L7.35576 7.03659L7.42345 6.97296C7.01968 7.37514 6.65906 7.81625 6.34716 8.28946C6.03139 8.75884 5.7516 9.2502 5.51004 9.75955C5.03637 10.7787 4.71715 11.8592 4.56236 12.9674C4.40707 14.0729 4.40176 15.1935 4.54656 16.3003C4.67969 17.4027 4.99673 18.4766 5.48522 19.4797C5.97827 20.4805 6.6124 21.4095 7.3693 22.24C8.12479 23.0724 8.97571 23.8182 9.90547 24.4626C10.3686 24.7848 10.85 25.0815 11.3473 25.3513C11.5955 25.4873 11.8482 25.6124 12.1054 25.7287C12.3573 25.8461 12.6166 25.948 12.8816 26.0337C12.9471 26.0534 13.0125 26.0732 13.0734 26.0863C13.1344 26.0995 13.2043 26.1105 13.2742 26.1236L13.703 26.2048C13.9895 26.2575 14.2738 26.3145 14.5581 26.3716C15.1267 26.4879 15.6863 26.6085 16.2594 26.7336L16.4851 26.7863L16.4309 27.0188L16.3384 27.4072L16.2955 27.6464L16.0564 27.5937C15.4742 27.4635 14.8921 27.3385 14.3099 27.2185C14.0189 27.1593 13.7278 27.1 13.4345 27.0452L12.9967 26.9618C12.839 26.9325 12.6837 26.8921 12.5319 26.8411C11.9563 26.6363 11.4006 26.3823 10.8712 26.0819C10.3444 25.7889 9.83443 25.4681 9.34363 25.1209C8.36307 24.4242 7.46951 23.6187 6.6811 22.7205C5.88838 21.8217 5.23398 20.8158 4.73836 19.7342C4.23987 18.6545 3.9266 17.5027 3.81098 16.3245C3.69076 15.1536 3.73022 13.9724 3.92832 12.8116Z",
    fill: "url(#paint10_linear_5253_12571)"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_41",
    d: "M7.5002 27.6175C6.64626 27.1102 5.88395 26.4697 5.24381 25.7218L5.07458 25.5155L5.30022 25.3729C5.38371 25.3202 7.36933 24.1025 9.54673 24.7695C11.7241 25.4365 12.128 26.8803 12.1416 26.9417L12.1641 27.0273L12.1213 27.1063C12.0947 27.1587 12.0646 27.2092 12.031 27.2577C11.3338 28.2889 9.35043 28.6795 7.5002 27.6175ZM9.39781 25.2325C7.86347 24.7651 6.3878 25.3619 5.81468 25.6472C6.38021 26.2551 7.03301 26.7806 7.75291 27.2072C9.33238 28.1178 11.0585 27.8282 11.6181 26.9988C11.6225 26.9895 11.6278 26.9807 11.6339 26.9724C11.5233 26.6828 11.0563 25.7327 9.39781 25.2325Z",
    fill: "#D42900"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_42",
    d: "M11.9001 26.9968C11.9001 26.9968 11.5639 25.6386 9.47227 24.9957C7.3806 24.3528 5.43109 25.5728 5.43109 25.5728C6.05583 26.2965 6.79731 26.9168 7.62655 27.4093C9.35945 28.4054 11.3406 28.061 11.9001 26.9968Z",
    fill: "url(#paint11_linear_5253_12571)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Vector_43",
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.49
  }, _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M5.68832 25.5682C5.68832 25.5682 8.01465 24.5391 9.63248 25.3619C11.2503 26.1847 10.2417 27.7382 9.09997 27.6614C7.95824 27.5846 5.55971 25.7656 5.68832 25.5682Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Vector_44",
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.49
  }, _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M5.91394 25.6532C5.91394 25.6532 7.5453 26.9873 8.31924 26.882C9.09318 26.7767 9.28272 25.7147 8.56068 25.2715C7.83863 24.8282 5.91394 25.6532 5.91394 25.6532Z",
    fill: "white"
  }))), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_45",
    d: "M2.64668 22.9599C1.91873 22.2887 1.30894 21.506 0.841579 20.6428L0.72876 20.4015L0.983731 20.3071C1.07624 20.2742 3.28073 19.4931 5.27086 20.5945C7.26098 21.696 7.33319 23.188 7.33544 23.2517V23.3394L7.27678 23.4075C7.23912 23.4532 7.19842 23.4964 7.15493 23.5369C6.24787 24.4058 4.22164 24.3795 2.64668 22.9599ZM5.0204 21.0136C3.62595 20.2391 2.05326 20.5199 1.43049 20.6801C1.84958 21.3925 2.37246 22.0421 2.98288 22.6088C4.33671 23.8244 6.07864 23.8968 6.80519 23.2012L6.8255 23.1793C6.78263 22.8743 6.52315 21.8474 5.0204 21.0136Z",
    fill: "#D42900"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_46",
    d: "M7.08053 23.2564C7.08053 23.2564 7.04894 21.8587 5.1423 20.8011C3.23565 19.7435 1.08081 20.5334 1.08081 20.5334C1.53308 21.3694 2.12217 22.1282 2.82499 22.7802C4.28713 24.1165 6.30208 24.1889 7.08053 23.2564Z",
    fill: "url(#paint12_linear_5253_12571)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Vector_47",
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.49
  }, _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M1.31989 20.5903C1.31989 20.5903 3.81997 20.0637 5.22118 21.2025C6.62239 22.3413 5.2979 23.649 4.19904 23.3374C3.10018 23.0258 1.15292 20.7571 1.31989 20.5903Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Vector_48",
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.49
  }, _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M1.52295 20.7173C1.52295 20.7173 2.82714 22.3585 3.60559 22.4134C4.38404 22.4683 4.80147 21.4721 4.19225 20.8906C3.58303 20.3092 1.52295 20.7173 1.52295 20.7173Z",
    fill: "white"
  }))), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_49",
    d: "M0.401604 15.6768C0.127641 14.8655 -0.00802838 14.0161 -3.2314e-05 13.1623V12.9297L0.245913 12.9429C0.333912 12.9429 2.37819 13.2435 3.44321 14.9C4.50822 16.5566 3.93058 17.7525 3.89448 17.7963L3.85838 17.8666L3.78392 17.8951C3.73654 17.9148 3.68464 17.9324 3.635 17.9477C2.57224 18.2593 1.01534 17.4168 0.401604 15.6768ZM3.07767 15.137C2.3263 13.9697 0.988263 13.5506 0.435449 13.4234C0.457334 14.143 0.584206 14.8559 0.812265 15.5407C1.33575 17.0284 2.66024 17.7942 3.51992 17.5484H3.54474C3.64402 17.2873 3.8832 16.3855 3.07767 15.137Z",
    fill: "#D42900"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_50",
    d: "M3.71172 17.7104C3.71172 17.7104 4.28484 16.6133 3.26044 15.0203C2.23605 13.4274 0.22561 13.1641 0.22561 13.1641C0.215889 13.9942 0.34467 14.8205 0.606938 15.6106C1.18006 17.2408 2.70763 18.1119 3.71172 17.7104Z",
    fill: "url(#paint13_linear_5253_12571)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Vector_51",
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.49
  }, _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M0.390356 13.3008C0.390356 13.3008 2.55423 13.9042 3.15894 15.3589C3.76365 16.8136 2.16387 17.2854 1.44409 16.5986C0.7243 15.9118 0.189538 13.3622 0.390356 13.3008Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Vector_52",
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.49
  }, _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M0.494141 13.4844C0.494141 13.4844 0.801008 15.2858 1.3809 15.6434C1.96079 16.0011 2.70765 15.3999 2.48201 14.7021C2.25637 14.0044 0.494141 13.4844 0.494141 13.4844Z",
    fill: "white"
  }))), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_53",
    d: "M1.78921 9.40349C1.91533 8.55421 2.18363 7.73074 2.58345 6.96578L2.69627 6.76172L2.89483 6.89117C2.96704 6.93945 4.66835 8.08041 4.86691 10.0266C5.06547 11.9729 4.00272 12.7869 3.96436 12.8198L3.89892 12.8659H3.81995C3.76805 12.8659 3.7139 12.8659 3.662 12.8461C2.55638 12.6531 1.54552 11.2246 1.78921 9.40349ZM4.43594 10.0617C4.29605 8.69258 3.28744 7.73812 2.85647 7.38486C2.54477 8.03994 2.33198 8.73535 2.22469 9.44957C2.01484 11.0118 2.85196 12.2691 3.73646 12.4205H3.76128C3.95985 12.2449 4.58712 11.5406 4.43594 10.0683V10.0617Z",
    fill: "#D42900"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_54",
    d: "M3.83584 12.6506C3.83584 12.6506 4.84896 11.9155 4.65716 10.0461C4.46537 8.17665 2.77534 7.06641 2.77534 7.06641C2.38827 7.81045 2.12839 8.61082 2.00592 9.4361C1.77577 11.1366 2.74827 12.5781 3.83584 12.6506Z",
    fill: "url(#paint14_linear_5253_12571)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Vector_55",
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.49
  }, _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M2.86555 7.2658C2.86555 7.2658 4.5285 8.74028 4.40215 10.3003C4.27579 11.8604 2.6354 11.6015 2.30597 10.6755C1.97654 9.74959 2.65571 7.24166 2.86555 7.2658Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Vector_56",
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.49
  }, _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M2.87452 7.46875C2.87452 7.46875 2.32622 9.22408 2.68273 9.78579C3.03923 10.3475 3.98691 10.1412 4.1065 9.43033C4.22609 8.71942 2.87452 7.46875 2.87452 7.46875Z",
    fill: "white"
  }))), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_57",
    d: "M10.0567 22.9653C10.0736 21.9925 10.2542 21.029 10.5914 20.1129L10.6884 19.8672L10.9321 19.9857C11.0201 20.0296 13.105 21.0828 13.6172 23.2418C14.1294 25.4009 13.0531 26.4738 13.0057 26.5177L12.9403 26.5791H12.8501C12.7899 26.5824 12.7297 26.5824 12.6695 26.5791C11.4015 26.5199 10.0521 25.0542 10.0567 22.9653ZM13.1366 23.3449C12.7778 21.809 11.5007 20.8875 10.9569 20.5496C10.7027 21.3309 10.5659 22.1438 10.5508 22.9632C10.5508 24.7514 11.679 26.0503 12.6921 26.0986H12.7237C12.9245 25.8638 13.5247 24.984 13.1366 23.3449Z",
    fill: "#D42900"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_58",
    d: "M12.8343 26.3412C12.8343 26.3412 13.87 25.3713 13.3781 23.2913C12.8862 21.2112 10.8306 20.1953 10.8306 20.1953C10.5051 21.0857 10.3306 22.0217 10.3139 22.9665C10.2981 24.9237 11.6068 26.4114 12.8343 26.3412Z",
    fill: "url(#paint15_linear_5253_12571)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Vector_59",
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.49
  }, _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M10.9547 20.4062C10.9547 20.4062 13.0464 21.8368 13.1344 23.6119C13.2224 25.387 11.3293 25.3234 10.8283 24.3272C10.3274 23.3311 10.7133 20.4062 10.9547 20.4062Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Vector_60",
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.49
  }, _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M10.993 20.6406C10.993 20.6406 10.6365 22.6856 11.1216 23.2736C11.6068 23.8617 12.6447 23.493 12.6718 22.6615C12.6988 21.8299 10.993 20.6406 10.993 20.6406Z",
    fill: "white"
  }))), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_61",
    d: "M6.76905 18.3945C7.26942 17.548 7.91066 16.7881 8.66666 16.1455L8.87425 15.9766L9.02768 16.196C9.08409 16.2772 10.3815 18.1707 9.75875 20.31C9.13599 22.4493 7.65581 22.8728 7.59263 22.8882L7.50463 22.9101L7.4234 22.8728C7.36888 22.8485 7.31611 22.8207 7.26545 22.7894C6.1869 22.1378 5.73337 20.2179 6.76905 18.3945ZM9.28491 20.1828C9.73619 18.6798 9.07507 17.2601 8.76594 16.7094C8.15873 17.2732 7.63818 17.919 7.22032 18.6271C6.31777 20.1828 6.65623 21.8591 7.52268 22.3769L7.54975 22.3923C7.84534 22.2804 8.79979 21.7933 9.28491 20.1828Z",
    fill: "#D42900"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_62",
    d: "M7.52948 22.6617C7.52948 22.6617 8.91715 22.2997 9.52186 20.2481C10.1266 18.1966 8.82464 16.3359 8.82464 16.3359C8.09693 16.9615 7.47887 17.6981 6.99472 18.5169C6.01319 20.2262 6.41934 22.1439 7.52948 22.6617Z",
    fill: "url(#paint16_linear_5253_12571)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Vector_63",
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.49
  }, _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M8.83599 16.5829C8.83599 16.5829 9.96418 18.8187 9.14963 20.4139C8.33508 22.009 6.72176 21.0655 6.76915 19.9553C6.81653 18.845 8.62841 16.4578 8.83599 16.5829Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Vector_64",
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.49
  }, _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M8.75474 16.8047C8.75474 16.8047 7.42347 18.4306 7.55209 19.1722C7.6807 19.9138 8.7773 20.0806 9.21278 19.3675C9.64827 18.6544 8.75474 16.8047 8.75474 16.8047Z",
    fill: "white"
  }))), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_65",
    d: "M6.35395 9.36277C7.1527 9.00065 8.00722 8.76864 8.88335 8.676L9.12253 8.65625V8.88883C9.12253 8.9744 9.06838 10.9821 7.50245 12.2086C5.93652 13.4351 4.65489 13.0182 4.60074 12.9985L4.52628 12.9722L4.48567 12.9042C4.46085 12.8581 4.43828 12.812 4.41572 12.7659C3.97572 11.7676 4.65038 10.1614 6.35395 9.36277ZM7.2204 11.8817C8.32151 11.0172 8.59228 9.67434 8.65546 9.1258C7.92508 9.23338 7.21403 9.44096 6.54349 9.74236C5.08586 10.4269 4.4631 11.7961 4.8151 12.5948C4.81792 12.6032 4.8217 12.6113 4.82638 12.6189C5.09489 12.6847 6.04257 12.8098 7.2204 11.8817Z",
    fill: "#D42900"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_66",
    d: "M4.67293 12.805C4.67293 12.805 5.86656 13.2285 7.3648 12.048C8.86303 10.8676 8.90139 8.89062 8.90139 8.89062C8.05172 8.9788 7.22252 9.20114 6.44645 9.54887C4.85119 10.3168 4.14268 11.8857 4.67293 12.805Z",
    fill: "url(#paint17_linear_5253_12571)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Vector_67",
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.49
  }, _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M8.77953 9.06639C8.77953 9.06639 8.42077 11.2255 7.01053 11.9781C5.60029 12.7306 4.92337 11.2496 5.53937 10.475C6.15536 9.70051 8.69379 8.8777 8.77953 9.06639Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Vector_68",
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.49
  }, _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M8.6058 9.19531C8.6058 9.19531 6.80069 9.70436 6.50736 10.3078C6.21403 10.9111 6.91577 11.5628 7.60171 11.2644C8.28765 10.966 8.6058 9.19531 8.6058 9.19531Z",
    fill: "white"
  }))), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_69",
    d: "M7.87928 4.21433C8.67803 3.85222 9.53255 3.6202 10.4087 3.52756L10.6479 3.50781V3.74039C10.6479 3.82597 10.5937 5.83363 9.03003 7.06016C7.46636 8.2867 6.18022 7.86981 6.12607 7.85006L6.05161 7.82373L6.011 7.75571C5.98618 7.70964 5.96361 7.66356 5.94105 7.61529C5.50105 6.61914 6.17571 5.01301 7.87928 4.21433ZM8.75476 6.73323C9.85587 5.86873 10.1266 4.5259 10.1898 3.97736C9.45501 4.08742 8.74007 4.29872 8.06656 4.60489C6.60894 5.28947 5.98618 6.65863 6.33817 7.45731L6.34945 7.48144C6.62022 7.53849 7.57016 7.66137 8.75476 6.73323Z",
    fill: "#D42900"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_70",
    d: "M6.19821 7.65658C6.19821 7.65658 7.38507 8.08005 8.89007 6.89959C10.3951 5.71913 10.4289 3.74219 10.4289 3.74219C9.57851 3.83025 8.74855 4.05258 7.97173 4.40044C6.37646 5.15742 5.67022 6.73722 6.19821 7.65658Z",
    fill: "url(#paint18_linear_5253_12571)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Vector_71",
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.49
  }, _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M10.3071 3.92742C10.3071 3.92742 9.94603 6.08648 8.5358 6.83908C7.12556 7.59168 6.44864 6.11281 7.06463 5.33608C7.68063 4.55934 10.2191 3.73214 10.3071 3.92742Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Vector_72",
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.49
  }, _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M10.1311 4.04297C10.1311 4.04297 8.32602 4.55421 8.03269 5.1576C7.73936 5.761 8.4411 6.41267 9.12704 6.11426C9.81298 5.81585 10.1311 4.04297 10.1311 4.04297Z",
    fill: "white"
  }))), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_73",
    d: "M5.57095 14.3613C6.27541 13.8482 7.06116 13.4503 7.89728 13.183L8.12291 13.1172L8.16804 13.3366C8.18609 13.42 8.55614 15.3969 7.28128 16.9087C6.00643 18.4205 4.66162 18.2647 4.60747 18.2581L4.52624 18.2471L4.47434 18.1879C4.43952 18.1489 4.40712 18.1078 4.37732 18.065C3.75005 17.1852 4.07271 15.4803 5.57095 14.3613ZM6.95862 16.6498C7.86117 15.5856 7.83635 14.2187 7.78671 13.6701C7.08854 13.9199 6.43116 14.2665 5.83494 14.6992C4.55332 15.658 4.23066 17.1128 4.74285 17.8368L4.75865 17.8588C5.03844 17.8632 5.99289 17.7951 6.95862 16.6498Z",
    fill: "#D42900"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_74",
    d: "M4.64805 18.0586C4.64805 18.0586 5.90034 18.2363 7.13007 16.7838C8.3598 15.3312 7.96719 13.3828 7.96719 13.3828C7.15632 13.6414 6.3942 14.0268 5.71081 14.5238C4.29831 15.577 3.93955 17.2643 4.64805 18.0586Z",
    fill: "url(#paint19_linear_5253_12571)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Vector_75",
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.49
  }, _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M7.89732 13.6022C7.89732 13.6022 7.99886 15.7964 6.76913 16.8035C5.5394 17.8106 4.57367 16.5073 5.01366 15.6252C5.45366 14.7432 7.76194 13.4245 7.89732 13.6022Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Vector_76",
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.49
  }, _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M7.74164 13.7461C7.74164 13.7461 6.09223 14.604 5.92074 15.2535C5.74926 15.903 6.58186 16.401 7.19334 15.9732C7.80482 15.5453 7.74164 13.7461 7.74164 13.7461Z",
    fill: "white"
  }))), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_77",
    d: "M38.9925 11.1754C39.956 8.91977 34.1616 8.36903 30.5468 8.36245C29.7052 6.85067 27.2638 2.62471 25.6347 1.45742C23.8296 0.160666 20.5939 5.24454 18.7054 8.36903C15.226 8.29443 8.43882 8.75082 9.47675 11.1754C10.3297 13.1699 13.2878 16.2088 15.0748 17.9246C13.9827 20.935 12.1415 28.0419 14.9598 27.7808C17.5704 27.5394 22.4284 25.014 24.2335 24.0332C26.0386 25.014 30.8966 27.5438 33.5072 27.7808C36.3299 28.0419 34.4865 20.935 33.3944 17.9246C35.1792 16.2088 38.1328 13.1699 38.9925 11.1754Z",
    fill: "#EEC700"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_78",
    d: "M39.5295 9.72701C38.3584 8.00021 33.7148 7.67986 30.9845 7.64475C29.809 5.56468 27.6564 2.01014 26.0701 0.87795C25.7591 0.651108 25.3804 0.529364 24.9916 0.531272C22.918 0.531272 20.5465 3.93881 18.2879 7.64475H17.9878C15.6976 7.64475 10.2304 7.84881 8.9397 9.72921C8.76723 9.97921 8.66377 10.2681 8.63927 10.5682C8.61477 10.8683 8.67005 11.1695 8.79981 11.4429C9.62338 13.3847 12.1844 16.1296 14.2287 18.1131C13.5946 19.9869 11.8324 25.7269 13.2968 27.7411C13.4641 27.9803 13.6902 28.1751 13.9546 28.3077C14.2191 28.4403 14.5134 28.5065 14.8108 28.5003C14.8808 28.5003 14.953 28.5003 15.0364 28.5003C17.5591 28.2655 21.8507 26.1394 24.2402 24.858C26.6297 26.1394 30.9214 28.2655 33.444 28.5003C33.5207 28.5003 33.5952 28.5003 33.6696 28.5003C33.9671 28.5069 34.2616 28.4408 34.5261 28.3082C34.7906 28.1756 35.0167 27.9806 35.1837 27.7411C36.6503 25.7291 34.8858 19.9869 34.2518 18.1131C36.2825 16.1384 38.8571 13.3913 39.6874 11.445C39.8154 11.1697 39.8681 10.8668 39.8404 10.5659C39.8127 10.2649 39.7056 9.97594 39.5295 9.72701ZM15.7675 18.1592L15.9232 17.7204L15.5915 17.411C13.9105 15.7983 10.9659 12.7988 10.1536 10.8943C10.1193 10.8398 10.1012 10.7772 10.1012 10.7133C10.1012 10.6494 10.1193 10.5868 10.1536 10.5323C10.6478 9.81259 13.4931 9.08412 17.9788 9.08412C18.2179 9.08412 18.4526 9.08412 18.6805 9.08412H19.1115L19.3371 8.71989C22.7217 3.12916 24.2763 1.95528 24.9893 1.95528C25.0639 1.95387 25.1365 1.97794 25.1947 2.0233C26.7222 3.12039 29.1794 7.40339 29.8947 8.69137L30.1046 9.06657H30.5423C34.9896 9.06657 37.8124 9.80162 38.302 10.5147C38.3391 10.5702 38.3588 10.635 38.3588 10.7012C38.3588 10.7674 38.3391 10.8322 38.302 10.8877C37.4897 12.7945 34.5451 15.7895 32.8641 17.4044L32.5324 17.7247L32.6881 18.1636C33.9156 21.547 34.7189 25.8739 33.9562 26.9183C33.9249 26.9702 33.8789 27.0123 33.8237 27.0396C33.7685 27.0668 33.7064 27.078 33.6448 27.0719C33.6193 27.0741 33.5936 27.0741 33.5681 27.0719C31.0455 26.8393 26.0521 24.2195 24.5809 23.412L24.2222 23.2167L23.8634 23.412C22.3922 24.2129 17.3989 26.8393 14.8785 27.0719H14.8018C14.74 27.0769 14.678 27.0652 14.6227 27.0381C14.5674 27.011 14.5208 26.9695 14.4881 26.9183C13.739 25.8673 14.5423 21.5426 15.7675 18.1592Z",
    fill: "url(#paint20_linear_5253_12571)"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_79",
    d: "M38.9925 11.1754C39.956 8.91977 34.1616 8.36903 30.5468 8.36245C29.7052 6.85067 27.2638 2.62471 25.6347 1.45742C23.8296 0.160666 20.5939 5.24454 18.7054 8.36903C15.226 8.29443 8.43882 8.75082 9.47675 11.1754C10.3297 13.1699 13.2878 16.2088 15.0748 17.9246C13.9827 20.935 12.1415 28.0419 14.9598 27.7808C17.5704 27.5394 22.4284 25.014 24.2335 24.0332C26.0386 25.014 30.8966 27.5438 33.5072 27.7808C36.3299 28.0419 34.4865 20.935 33.3944 17.9246C35.1792 16.2088 38.1328 13.1699 38.9925 11.1754Z",
    fill: "url(#paint21_linear_5253_12571)"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_80",
    d: "M36.6143 11.7105C37.422 9.82136 32.5528 9.3584 29.5292 9.35181C28.823 8.08359 26.7764 4.54001 25.4068 3.55922C23.886 2.46214 21.1806 6.73637 19.5966 9.3584C16.6769 9.29476 10.984 9.67655 11.8527 11.7105C12.5703 13.3869 15.0523 15.9343 16.5505 17.3737C15.6344 19.8992 14.0888 25.8607 16.4535 25.6435C18.6444 25.4394 22.7195 23.3221 24.2335 22.4992C25.7498 23.3221 29.8248 25.4394 32.0135 25.6435C34.3804 25.8629 32.8326 19.8992 31.9187 17.3737C33.4147 15.9343 35.8967 13.3869 36.6143 11.7105Z",
    fill: "url(#paint22_linear_5253_12571)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2",
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.43
  }, _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_81",
    d: "M33.3944 16.3994C33.5163 16.7351 33.6471 17.1235 33.7803 17.547C35.5854 15.7916 38.196 13.0358 38.9925 11.1707C39.0856 10.9823 39.1193 10.7713 39.0891 10.5643C39.059 10.3573 38.9665 10.1637 38.8233 10.0078C37.7966 12.0001 35.0754 14.7823 33.3944 16.3994Z",
    fill: "#DB5800"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_82",
    d: "M15.0749 16.3999C13.3916 14.7828 10.6681 11.9984 9.64374 10.0039C9.50022 10.1606 9.40773 10.3551 9.37801 10.5629C9.34828 10.7707 9.38266 10.9824 9.47677 11.1712C10.2733 13.0362 12.8907 15.7789 14.689 17.5474C14.8221 17.1152 14.953 16.7356 15.0749 16.3999Z",
    fill: "#DB5800"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Vector_83",
    style: {
      mixBlendMode: "multiply"
    }
  }, _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M33.5073 26.2576C30.8967 26.0141 26.0409 23.4908 24.2336 22.5078C22.4285 23.4908 17.5705 26.0185 14.9598 26.2576C14.0415 26.3432 13.6196 25.6433 13.5022 24.5637C13.351 26.4529 13.6579 27.8989 14.9598 27.7782C17.5705 27.5368 22.4285 25.0114 24.2336 24.0306C26.0387 25.0114 30.8967 27.5412 33.5073 27.7782C34.8092 27.8989 35.1161 26.4617 34.9649 24.5637C34.8476 25.6433 34.4256 26.3432 33.5073 26.2576Z",
    fill: "#DB5800"
  })))), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_84",
    d: "M18.1773 24.7485C18.3263 24.6892 22.2388 23.0765 23.3038 22.3854C24.3688 21.6942 24.4004 21.828 27.4488 23.568C30.4972 25.308 32.0609 25.5647 32.6114 25.1039C33.162 24.6431 32.7942 25.8368 31.3411 25.5208C29.888 25.2049 25.0097 23.0831 24.6216 22.7825C24.2335 22.4819 19.3755 25.4506 17.0424 25.5493C14.7093 25.6481 16.4309 25.4352 18.1773 24.7485Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Vector_85",
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.49
  }, _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M29.5292 9.35181C28.823 8.08359 26.7764 4.54001 25.4068 3.55922C23.886 2.46214 21.1806 6.73637 19.5966 9.35839C16.6769 9.29476 10.984 9.67655 11.8527 11.7105C12.5703 13.3869 15.0523 15.9343 16.5505 17.3737C16.3249 18.01 16.0496 18.8657 15.8104 19.7873C18.6016 20.1778 22.4419 19.1575 25.2398 18.1526C29.9647 16.4565 31.5419 16.0945 36.4789 12.0089C36.5285 11.9102 36.5759 11.8137 36.6143 11.7193C37.422 9.82136 32.5618 9.3584 29.5292 9.35181Z",
    fill: "white"
  }))), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_86",
    opacity: 0.49,
    d: "M29.5292 9.35181C28.823 8.08359 26.7764 4.54001 25.4068 3.55922C23.886 2.46214 21.1806 6.73637 19.5966 9.3584C16.6769 9.29476 10.984 9.67655 11.8527 11.7105C11.8527 11.7259 11.8663 11.7391 11.8708 11.7544C12.6199 10.4182 17.1124 10.1505 19.5966 10.2031C21.1761 7.58332 23.8838 3.31786 25.4068 4.40617C26.7764 5.38476 28.823 8.93053 29.5292 10.1966C32.0744 10.1966 35.908 10.5301 36.5962 11.7522C36.6036 11.7389 36.6096 11.725 36.6143 11.7105C37.422 9.82136 32.5618 9.3584 29.5292 9.35181Z",
    fill: "white"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_87",
    d: "M24.8698 3.38299C24.1432 3.36324 22.3381 5.01106 21.052 7.05163C19.7659 9.0922 23.7596 4.87941 24.8698 4.9584C25.9799 5.03739 26.262 3.42029 24.8698 3.38299Z",
    fill: "white"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_88",
    d: "M25.7903 1.7045C25.7903 1.7045 25.6414 3.50811 25.2488 3.30624C25.1102 3.23689 24.954 3.20768 24.7988 3.22207C24.6437 3.23646 24.496 3.29385 24.3733 3.38743L23.9988 1.7045C23.9988 1.7045 24.9984 0.787341 25.7903 1.7045Z",
    fill: "white"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_89",
    d: "M10.0522 9.80859C10.5552 9.91557 11.0373 10.1 11.4805 10.3549L12.013 10.7148C11.827 10.8878 11.7156 11.1231 11.7016 11.373C11.7016 11.7482 11.7625 11.7833 11.7625 11.7833C11.7625 11.7833 9.58059 11.5968 9.39331 10.9057C9.20603 10.2145 9.80849 9.88758 10.0522 9.80859Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Vector_90",
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.43
  }, _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M38.2727 9.66893C37.9175 9.80654 37.5767 9.977 37.255 10.178C37.0299 10.3069 36.8408 10.4878 36.7045 10.7046C36.7498 10.8478 36.7823 10.9947 36.8015 11.1434V11.5098C36.8015 11.5098 38.2095 11.3562 38.6404 11.1434C39.0714 10.9306 39.0488 10.3074 38.936 10.156C38.8232 10.0046 38.4035 9.61627 38.2727 9.66893Z",
    fill: "#DB5800"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Vector_91",
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.43
  }, _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M15.894 25.6085C15.894 25.6085 15.2915 27.5284 15.1178 27.6446C14.944 27.7609 14.2152 27.8641 13.9444 27.3967C13.6737 26.9294 13.5383 26.609 13.6692 26.3282C13.8 26.0473 15.3908 25.1367 15.3908 25.1367C15.3908 25.1367 15.6074 25.6085 15.894 25.6085Z",
    fill: "#DB5800"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Vector_92",
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.43
  }, _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M32.458 25.6058C32.458 25.6058 33.0582 27.5257 33.2342 27.6486C33.4102 27.7714 34.1368 27.868 34.4053 27.4006C34.6738 26.9333 34.8159 26.6063 34.6828 26.3321C34.5497 26.0578 32.9612 25.1406 32.9612 25.1406C32.9612 25.1406 32.7446 25.6058 32.458 25.6058Z",
    fill: "#DB5800"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Vector_93",
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.43
  }, _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M24.3824 22.7969V24.0278C24.3824 24.0278 17.1168 27.5823 16.194 27.7579L15.2734 27.9312L16.194 26.0267C16.194 26.0267 23.5678 23.4771 24.3824 22.7969Z",
    fill: "#DB5800"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Vector_94",
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.7
  }, _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M19.5966 9.35545L18.7053 8.36369C18.7053 8.36369 21.0023 4.16844 22.6991 2.68738C24.3959 1.20632 25.2714 0.877197 25.2714 2.08399C25.2714 3.29078 24.8788 3.38293 24.8788 3.38293C24.8788 3.38293 22.9767 3.53872 19.5966 9.35545Z",
    fill: "white"
  }))), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_95",
    d: "M19.5696 10.2061L20.5331 14.4671L22.4555 13.5785V21.9163H27.4195V8.3125H23.7416L19.5696 10.2061ZM26.79 8.93784V21.3085H23.085V12.6021L20.9843 13.5785L20.3074 10.5549L23.8838 8.93784H26.79Z",
    fill: "#D42900"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_96",
    d: "M23.4663 11.2931H24.1432V20.2891H25.7227V9.97656H24.1048L21.51 11.1373L21.7356 12.0939L23.4663 11.2931ZM24.2538 10.5778H25.0977V19.666H24.7818V10.6699H24.0372L24.2538 10.5778Z",
    fill: "#D42900"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_97",
    d: "M27.0336 21.6188H22.7059V13.0923L20.6932 14.0226L19.8719 10.3803L23.7416 8.625H27.0336V21.6188ZM24.3959 19.9688H25.3459V10.2728H24.1139L21.8101 11.315L21.8868 11.6529L23.3242 10.9947H24.3959V19.9688Z",
    fill: "url(#paint23_linear_5253_12571)"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_98",
    d: "M23.5521 11.8097H23.516L21.2889 12.8387L20.8376 10.8486L23.9266 9.45312H26.183V20.797H23.5521V11.8097Z",
    fill: "url(#paint24_linear_5253_12571)"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_99",
    d: "M20.8398 10.8352L20.8963 11.0765L23.9288 9.70519H26.1897V9.4375H23.9288L20.8398 10.8352Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Vector_100",
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.49
  }, _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M19.8719 10.3816L20.8399 10.8423L23.9289 9.44465H26.1898L27.0336 8.63281H23.7416L19.8719 10.3816Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Vector_101",
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.49
  }, _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M23.9289 9.44465H26.1898L27.0337 8.63281H23.7416L23.9289 9.44465Z",
    fill: "white"
  }))), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_102",
    opacity: 0.46,
    d: "M21.2889 12.8338L20.6932 14.0186L22.7059 13.0883L23.516 11.8047L21.2889 12.8338Z",
    fill: "#D42900"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_103",
    opacity: 0.46,
    d: "M23.5521 20.7969L22.7059 21.6197H27.0337L26.1898 20.7969H23.5521Z",
    fill: "#D42900"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Vector_104",
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.49
  }, _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M26.1897 14.3373V9.45312H23.9333L20.8398 10.8486L21.2911 12.8387L23.5182 11.8097H23.5543V16.0685C24.6149 15.8111 25.5482 15.1981 26.1897 14.3373Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_105",
    style: {
      mixBlendMode: "overlay"
    },
    d: "M23.6762 0.878906C22.205 0.878906 21.0137 1.95844 21.0137 3.29249C21.0137 4.62654 22.205 5.70607 23.6762 5.70607C25.1474 5.70607 26.341 4.62654 26.341 3.29249C26.341 1.95844 25.1474 0.878906 23.6762 0.878906Z",
    fill: "url(#paint25_radial_5253_12571)"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_106",
    opacity: 0.7,
    d: "M21.2438 6.46857C21.959 5.68964 24.0597 3.29142 24.0597 3.29142C24.0597 3.29142 25.8175 0.0879367 25.8648 0.000170114C25.8648 -0.0261599 23.6085 3.01276 23.6085 3.01276L21.2438 6.46857Z",
    fill: "white"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_107",
    d: "M24.256 2.72189C23.6085 2.2304 23.7258 0.843686 23.719 0.453125V0.828327C23.719 0.766891 23.719 0.70326 23.719 0.690095V0.453125C23.719 0.565027 23.719 0.742755 23.6829 0.949006C23.6829 0.949006 23.4934 2.33791 23.1504 2.62535C22.3787 3.2836 20.4428 3.15634 21.1806 3.17389C23.692 3.22655 23.692 5.6138 23.7168 6.39712V6.00217C23.7168 6.03069 23.7168 6.05483 23.7168 6.06799V6.39712C23.7709 4.54305 23.7642 3.36917 25.9596 3.21338C26.6884 3.15853 25.0142 3.29237 24.256 2.72189Z",
    fill: "white"
  })))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_5253_12571",
    x1: 38.8652,
    y1: 11.4573,
    x2: 37.4345,
    y2: 26.474,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE800"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D45900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_5253_12571",
    x1: 41.0363,
    y1: 24.7531,
    x2: 37.5896,
    y2: 27.7613,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE800"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D45900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_5253_12571",
    x1: 46.6296,
    y1: 18.6259,
    x2: 43.9189,
    y2: 22.261,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE800"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D45900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_5253_12571",
    x1: 46.2561,
    y1: 13.4601,
    x2: 45.6416,
    y2: 17.3774,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE800"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D45900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_5253_12571",
    x1: 43.9894,
    y1: 7.99519,
    x2: 45.1336,
    y2: 11.801,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE800"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D45900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_5253_12571",
    x1: 35.6554,
    y1: 21.0854,
    x2: 36.41,
    y2: 25.5276,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE800"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D45900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_5253_12571",
    x1: 36.7543,
    y1: 16.5132,
    x2: 39.5783,
    y2: 20.0923,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE800"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D45900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_5253_12571",
    x1: 36.6242,
    y1: 11.1753,
    x2: 40.5266,
    y2: 12.3148,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE800"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D45900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_5253_12571",
    x1: 35.0851,
    y1: 6.03456,
    x2: 38.9875,
    y2: 7.17405,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE800"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D45900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_5253_12571",
    x1: 39.8877,
    y1: 14.9168,
    x2: 43.4479,
    y2: 16.8467,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE800"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D45900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_5253_12571",
    x1: 7.47523,
    y1: 9.43481,
    x2: 8.88426,
    y2: 24.4702,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE800"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D45900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_5253_12571",
    x1: 4.69411,
    y1: 26.3116,
    x2: 8.1545,
    y2: 29.3323,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE800"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D45900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_5253_12571",
    x1: 5.14494,
    y1: 19.2178,
    x2: 7.85717,
    y2: 22.8546,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE800"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D45900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_5253_12571",
    x1: 1.69063,
    y1: 12.9007,
    x2: 2.30324,
    y2: 16.8183,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE800"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D45900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_5253_12571",
    x1: 10.8444,
    y1: 13.5617,
    x2: 9.71837,
    y2: 17.3509,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE800"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D45900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_5253_12571",
    x1: 10.671,
    y1: 19.0776,
    x2: 9.9106,
    y2: 23.5243,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE800"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D45900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_5253_12571",
    x1: 9.07973,
    y1: 11.4218,
    x2: 6.25455,
    y2: 15.0028,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE800"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D45900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_5253_12571",
    x1: 12.3791,
    y1: 7.6046,
    x2: 8.4767,
    y2: 8.74409,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE800"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D45900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_5253_12571",
    x1: 13.9181,
    y1: 2.46387,
    x2: 10.0177,
    y2: 3.60246,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE800"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D45900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_5253_12571",
    x1: 11.5791,
    y1: 13.3046,
    x2: 8.01819,
    y2: 15.2228,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE800"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D45900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_5253_12571",
    x1: 25.7678,
    y1: 33.9199,
    x2: 23.783,
    y2: 2.14785,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D45900"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#D42900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_5253_12571",
    x1: 9.36845,
    y1: 14.5193,
    x2: 39.0985,
    y2: 14.5193,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE800"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D45900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_5253_12571",
    x1: 11.7625,
    y1: 14.5169,
    x2: 36.7045,
    y2: 14.5169,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE800"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D45900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_5253_12571",
    x1: 23.4528,
    y1: 22.2595,
    x2: 23.4528,
    y2: 5.01121,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE800"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D45900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_5253_12571",
    x1: 23.516,
    y1: 9.80639,
    x2: 23.516,
    y2: 22.4908,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE800"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D45900"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint25_radial_5253_12571",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(23.6762 3.29468) scale(2.57453 2.50354)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5253_12571"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 28.5,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHappyAsset11);
export default __webpack_public_path__ + "static/media/happyAsset 1 1.a1be08b4f5a6337d56e5201c1d93b651.svg";
export { ForwardRef as ReactComponent };